<template>
  <div class="w-50 p-3 mx-auto mt-4">
    <h1 class="mt-4 mb-4 text-center">
      Modifier un attribut MIRAKL
    </h1>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-card class="mt-3 mb-3">
        <b-card-body>
          <h4 class="text-center mb-3">Modifier les catégories associées</h4>
          <b-list-group>
            <b-list-group-item
              v-for="(item, index) in form.categoriesMirakls"
              :key="index"
              class="d-flex align-items-center justify-content-between"
              >{{ item.hierarchyLabel }}
              <b-button
                class="float-right"
                variant="danger"
                @click="form.categoriesMirakls.splice(index, 1)"
                >Supprimer</b-button
              >
            </b-list-group-item>
          </b-list-group>

          <gwzAutoComplete
            id="select-categorie"
            input-label="Choisir une catégorie"
            :http="httpMirakl"
            labelName="hierarchyLabel"
            queryParamName="hierarchyLabel"
            nameEndpoint="listMirakl"
            input-place-holder="Rechercher une catégorie MIRAKL"
            @response="addMiraklCategory"
          ></gwzAutoComplete>
        </b-card-body>
      </b-card>

      <b-card>
        <b-card-body>
          <h4 class="text-center mb-3">Modifier la description</h4>
          <ValidationProvider rules="required" v-slot="validationContext">
            <b-form-group
              label-cols="7"
              label-cols-lg="5"
              label-size="small"
              label="Label attribut MIRAKL"
              label-for="categories"
            >
              <b-form-input
                id="categories"
                v-model="form.label"
                :state="getValidationState(validationContext)"
                aria-describedby="labels-mirakl-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="labels-mirakl-feedback">{{
                validationContext.errors[0]
              }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <b-form-group
            label="Description"
            label-for="description"
            label-cols="7"
            label-cols-lg="5"
          >
            <b-form-textarea
              id="description"
              rows="3"
              max-rows="6"
              v-model="form.description"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            label="Type"
            label-for="type"
            label-cols="7"
            label-cols-lg="5"
          >
            <b-form-select
              id="type"
              :options="[
                'TEXT',
                'LONG_TEXT',
                'MEDIA',
                'DATE',
                'INTEGER',
                'DECIMAL',
                'LIST',
                'LIST_MULTIPLE_VALUES',
                'MULTIPLE',
                'MEASUREMENT'
              ]"
              v-model="form.type"
            ></b-form-select>
          </b-form-group>

          <b-form-group
            label-cols="7"
            label-cols-lg="5"
            label-size="small"
            label="Type de paramètre"
            label-for="parameter"
          >
            <b-form-input
              id="parameter"
              v-model="form.typeParameters"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label-cols="7"
            label-cols-lg="5"
            label-size="small"
            label="Code unique"
            label-for="code"
          >
            <b-form-input
              id="code"
              :value="form.code"
              :state="getValidationState(validationContext)"
              aria-describedby="code-mirakl-feedback"
              aria-required="true"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-card-body>
        <div class="text-right">
          <gwz-button
            submitButtonText="Valider"
            @click="handleSubmit(onSubmit)"
          />
          <b-button variant="secondary" class="m-2" @click="cancel"
            >Annuler</b-button
          >
        </div>
      </b-card>
    </ValidationObserver>
  </div>
</template>

<script>
import gwzAutoComplete from "@/components/gwzAutoComplete";
import { required } from "vee-validate/dist/rules";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import GwzButton from "@/components/gwzButton";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { cateRowMixin } from "@/mixins/attributes";

// Override the default message.
extend("required", {
  ...required,
  message: "Ce champ est obligatoire"
});
export default {
  name: "AddAttribut",
  mixins: [cateRowMixin],
  components: {
    GwzButton,
    gwzAutoComplete,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("categories"),
      data: [],
      categoriesMiraklsLabel: [],
      categoryId: "",
      form: {
        label: "",
        categoriesMirakls: [],
        description: "",
        example: "",
        type: "",
        typeParameters: "",
        transformations: "",
        code: "",
        roles: "",
        variant: "false",
        validations: ""
      },
      validationContext: {}
    };
  },
  computed: {
    ...mapGetters(["isError"]),
    ...mapGetters(["isLoading"])
  },
  methods: {
    ...mapActions(["setErrors"]),
    ...mapMutations({ setLoading: "SET_LOADING" }),
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    async onSubmit() {
      delete this.form.code;
      delete this.form.import;
      delete this.form.roles;

      this.form.categoriesMirakls.forEach(function(item, index) {
        this[index] = item["@id"];
      }, this.form.categoriesMirakls); // use arr as this

      await this.$store.dispatch("attributes/editAttribute", {
        id: this.id,
        form: this.form
      });
      (await this.isError) ? "" : this.$router.push({ name: "Attributes" });
    },

    cancel() {
      this.$router.push({ name: "Attributes" });
    }
  },
  async created() {
    try {
      const { data } = await this.$gwzApi
        .service("attributes")
        .getMiraklAttribute(this.id);
      this.form = data;
      // We do not need the import key (it breaks the API. See with Pierre Alain)

      // this.setCaterory();
    } catch (e) {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
label {
  justify-content: left !important;
}
</style>
